export default {
    name: "Spread by hour",
    data:
    {
        "id": "ae732f2d-5bc7-4148-ae6f-57b3ee3b7b77",
        "title": "PVB/TTF by hour",
        "type": "Formatter",
        "config": {
            "type_id": "group_by",
            "group_by": "hour",
            "agg_func": "mean",
            "child": {
                "id": "c974bdbe-ae8a-4ca5-bf77-0f37e6312105",
                "title": "PVB WD / TTF DA",
                "type": "Composite",
                "config": {
                    "operator": "Subtract",
                    "combine_on": "exact_match",
                    "left": {
                        "id": "657323d1-55e7-4b80-b225-67ca2665e625",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 17,
                            "product_id": "49",
                            "hour": "25",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    },
                    "right": {
                        "id": "4c8ff838-76e6-46f6-a453-4f9b18056b9a",
                        "type": "Single",
                        "config": {
                            "type_id": "vwap",
                            "hub_id": 14,
                            "product_id": 1,
                            "hour": "25",
                            "start_date": "2025-01-28",
                            "end_date": "2025-08-27"
                        }
                    }
                }
            },
            "start_date": "2025-01-28",
            "end_date": "2025-08-27"
        }
    }

}